import { SellerFeatures } from '../enums/seller-features';
import { useIsSellerFeatureEnabled } from './use-is-seller-feature-enabled';
import { useIsAutoSplitSellerSettingEnabled } from './use-seller-setting';

export const useIsAutoSplitEnabledForSeller = () => {
  const isSellerSettingEnabled = useIsAutoSplitSellerSettingEnabled();
  const isSellerFeatureEnabled = useIsSellerFeatureEnabled(SellerFeatures.AutoSplit);
  return isSellerSettingEnabled || isSellerFeatureEnabled;
};
